import {NewsService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        news: []
    },
    mutations: {
        saveNews(current, news) {
            current.news.splice(0);
            current.news = news;
        }

    },
    actions: {
        async getNewsAction({ commit}, all) {
            await bindLoading(commit, async () => commit('saveNews', await NewsService.getNews(all)), 'news')
        },

        async deleteNewsAction({ commit, state}, id) {
            return await bindLoading(commit, async () => {
                const result = await NewsService.deleteNews(id);
                if (result.success) {
                    const newNews = state.news.filter(n => n.id!==id);
                    commit('saveNews', newNews);
                }
                return result;
            }, 'news');

        },

        async updateNewsAction({dispatch, commit}, news) {
            return await bindLoading(commit, async () => {
                const result = await NewsService.updateNews(news);
                if (result.success) {
                    dispatch('getNewsAction', true);
                }
                return result;
            }, 'news');

        },

        async insertNewsAction({dispatch, commit, state}, news) {
            return await bindLoading(commit, async () => {
                const result = await NewsService.insertNews({...news});
                if (result.success) {
                    dispatch('getNewsAction', true);
                }
                return result;
            }, 'news');

        },


    }
}